var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('LayoutDefault',{scopedSlots:_vm._u([{key:"main",fn:function(){return [_c('b-row',{staticClass:"d-flex mt-5 mr-1"},[_c('b-col',[_c('h2',{staticClass:"welcome-title text-center"},[_vm._v("Bem-vindo(a) "+_vm._s(_vm.$auth.user().name)+"!")])])],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }